const STYLES = {
  posted: { bg: "bg-zinc-800", text: "text-zinc-200", dot: "bg-zinc-400", label: "POSTED" },
  bidding: { bg: "bg-blue-900/40", text: "text-blue-300", dot: "bg-blue-400", label: "BIDDING" },
  confirmed: { bg: "bg-[#FF5A00]/15", text: "text-[#FF5A00]", dot: "bg-[#FF5A00]", label: "CONFIRMED" },
  in_transit: { bg: "bg-[#FFD700]/15", text: "text-[#FFD700]", dot: "bg-[#FFD700]", label: "IN TRANSIT" },
  delivered: { bg: "bg-emerald-900/40", text: "text-emerald-300", dot: "bg-emerald-400", label: "DELIVERED" },
  open: { bg: "bg-zinc-800", text: "text-zinc-200", dot: "bg-zinc-400", label: "OPEN" },
  accepted: { bg: "bg-emerald-900/40", text: "text-emerald-300", dot: "bg-emerald-400", label: "ACCEPTED" },
  rejected: { bg: "bg-red-900/40", text: "text-red-300", dot: "bg-red-400", label: "REJECTED" },
};

export function StatusBadge({ status, testId }) {
  const s = STYLES[status] || STYLES.posted;
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center gap-2 px-2 py-1 ${s.bg} ${s.text} text-[10px] font-semibold tracking-wider uppercase rounded-sm`}
    >
      <span className={`w-1.5 h-1.5 ${s.dot} rounded-full`} />
      {s.label}
    </span>
  );
}
